import { DeviceType } from '../utils/helpers/getDeviceType';
import { useClient } from './useClient';
import useScreenSize from './useScreenSize';
import { usePageProps } from '../context/PageContext';

export const useResponsive = () => {
  const { deviceType } = usePageProps();

  const isMobile = deviceType === DeviceType.mobile;
  const isTablet = deviceType === DeviceType.tablet;
  const isDesk = !isMobile && !isTablet;

  const isClient = useClient();
  const { isSmall, isSmallOrLargeDesktop, isMedium } = useScreenSize();

  return {
    device: {
      isMobile,
      isTablet,
      isDesk
    },
    showOnMobile: (isMobile && !isClient) || (isSmall && isClient),
    showOnTabledOrMobile:
      (!isDesk && !isClient) || (!isSmallOrLargeDesktop && isClient),
    showOnTablet: (isTablet && !isClient) || (isMedium && isClient),
    showOnDesk: (isDesk && !isClient) || (isSmallOrLargeDesktop && isClient),
    hideOnMobile: (!isMobile && !isClient) || (isClient && !isSmall)
  };
};
